var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hint-v3-text"},[_c('span',{staticClass:"hint-v3-text__label",domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('div',{class:_vm.iconClassModifier,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showHint.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }